"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIRECTION_DELTAS = void 0;
exports.createActor = createActor;
exports.stepFrom = stepFrom;
exports.moveActor = moveActor;
exports.facingTile = facingTile;
exports.interactionTarget = interactionTarget;
const world_1 = require("./world");
exports.DIRECTION_DELTAS = {
    up: { x: 0, y: -1 },
    down: { x: 0, y: 1 },
    left: { x: -1, y: 0 },
    right: { x: 1, y: 0 },
};
function createActor(world, facing = 'down') {
    return { x: world.spawn.x, y: world.spawn.y, facing };
}
/** The tile one step from `pos` in `direction`, whether or not it is walkable. */
function stepFrom(pos, direction) {
    const delta = exports.DIRECTION_DELTAS[direction];
    return { x: pos.x + delta.x, y: pos.y + delta.y };
}
/**
 * One grid step.
 *
 * Turning always succeeds even when the step does not, which is what makes a
 * blocked direction still useful: tap into a wall to face the bed, then press
 * OK to examine it. That is the RPG Maker convention and it is why examine
 * never needs its own aiming control.
 */
function moveActor(world, actor, direction) {
    const turned = { ...actor, facing: direction };
    const target = stepFrom(actor, direction);
    if (!(0, world_1.isWalkable)(world, target.x, target.y))
        return { actor: turned, moved: false };
    return { actor: { ...turned, ...target }, moved: true };
}
/** The tile the actor is looking at. */
function facingTile(actor) {
    return stepFrom(actor, actor.facing);
}
/**
 * What pressing OK would act on: the object the actor faces, or the one it is
 * standing on when it faces nothing.
 *
 * The fallback is what makes walkable objects reachable at all — you cannot
 * stand next to a rug and face it, you stand *on* it.
 */
function interactionTarget(world, actor) {
    const ahead = facingTile(actor);
    return (0, world_1.objectAt)(world, ahead.x, ahead.y) ?? (0, world_1.objectAt)(world, actor.x, actor.y);
}
//# sourceMappingURL=movement.js.map